export default {
  complete: 'Credit + Personal TR + Business TR + Interim'
}
